import React from "react";
import ReactECharts from "echarts-for-react";
import PropTypes from "prop-types";

const ChartLine = ({ data, title, sub_title }) => {
  ChartLine.propTypes = {
    data: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    sub_title: PropTypes.string.isRequired,
  };

  const brightColors = ["#0a6ec7", "#33A1FF", "#5ea7ec"];

  const seriesData = data.map((item) => ({
    value: item.cargo_count,
    name: item.machine.name,
  }));

  const colors = seriesData.map((_, index) => brightColors[index % brightColors.length]);

  const getOption = () => {
    return {
      title: {
        text: title,
        left: "center",
        top: 10,
        textStyle: {
          fontFamily: "Vazir",
          fontSize: 14,
          fontWeight: "bold",
          color: "#000",
        },
      },
      tooltip: {
        trigger: "item",
        textStyle: {
          fontFamily: "Vazir",
          fontSize: 12,
          fontWeight: "normal",
        },
        padding: [10, 15],
      },
      legend: {
        show: true,
        top: "bottom",
        left: "center",
        textStyle: {
          fontFamily: "Vazir",
          fontSize: 12,
          fontWeight: "normal",
        },
      },
      xAxis: {
        type: "category",
        data: seriesData.map((item) => item.name),
        axisLabel: {
          fontFamily: "Vazir",
          fontSize: 11,
          fontWeight: "normal",
          color: "#000",
          interval: 0,
          rotate: 45,
          formatter: function (value) {
            return value.length > 10 ? value.substring(0, 10) + "..." : value;
          },
        },
        axisLine: {
          lineStyle: {
            color: "#ddd",
          },
        },
        axisTick: {
          show: false,
        },
      },
      yAxis: {
        type: "value",
        axisLabel: {
          fontFamily: "Vazir",
          fontSize: 11,
          fontWeight: "normal",
        },
        axisLine: {
          lineStyle: {
            color: "#ddd",
          },
        },
        axisTick: {
          show: false,
        },
      },
      series: [
        {
          name: sub_title,
          type: "bar", // بار (میله‌ها)
          data: seriesData.map((item) => item.value),
          itemStyle: {
            color: (params) => colors[params.dataIndex],
            borderRadius: [10, 10, 0, 0], // گوشه‌های میله‌ها گرد
            shadowBlur: 10,
            shadowColor: "rgba(0, 0, 0, 0.3)",
            shadowOffsetX: 3,
            shadowOffsetY: 3,
          },
          barWidth: "30%", // عرض میله‌ها
          animationDelay: (idx) => idx * 100, // انیمیشن تدریجی برای میله‌ها
        },
        {
          name: sub_title,
          type: "line", // خط (خط میانه)
          data: seriesData.map((item) => item.value),
          itemStyle: {
            color: "#FF7F50", // رنگ جذاب برای خط
            borderWidth: 3,
            borderType: "solid",
          },
          lineStyle: {
            width: 3,
            type: "dashed", // خط نقطه‌چین
            shadowBlur: 10,
            shadowColor: "rgba(0, 0, 0, 0.2)",
          },
          symbol: "circle", // نقاط دایره‌ای روی خط
          symbolSize: 8,
          smooth: true, // خط صاف
          animationDelay: (idx) => idx * 150, // انیمیشن تدریجی برای خط
        },
      ],
    };
  };

  return (
    <ReactECharts
      option={getOption()}
      style={{ height: 280, width: "100%", margin: 0, padding: 0 }}
    />
  );
};

export default ChartLine;
